import { apiSlice } from 'app/api/apiSlice'
import { removeEmptyKeys } from 'utilities'
import { format } from 'date-fns'

export const auditLogApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getAuditLogs: builder.query({
      query: ({ page, limitNumber, params }) => {
        return {
          url: `/auditlog/${page}/params`,
          params: { limitNumber, ...removeEmptyKeys(params) },
        }
      },
      transformResponse: (response, meta, args) => {
        let parsedBoUsers = response.rows.map((log) => {
          return {
            ...log,
            summary: log.summary.summary,
            summaryObject: log.summary,
          }
        })
        return {
          rows: parsedBoUsers,
          count: response.count,
          pages: response.pages,
        }
      },
      providesTags: ['logs'],
    }), 
    getAuditActions: builder.query({
      query: () => {
        return {
          url: `/auditlog/getactions`,
        }
      },
      providesTags: ['auditactions'],
    }), 
  }),
  overrideExisting: true,
})

export const {
  useGetAuditLogsQuery,
  useGetAuditActionsQuery,
} = auditLogApiSlice
